import { BatchModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { defaultBatchModelDto } from './data/batch.data';
import { RemoteDepositItem } from './remote-deposit-item.entity';
import { RemoteDepositLocation } from './remote-deposit-location.entity';

export class RemoteDepositBatch extends DomainEntity<BatchModelDto> {
    constructor(
        dto = defaultBatchModelDto,
        public location?: RemoteDepositLocation,
        public checks?: RemoteDepositItem[]
    ) {
        super(dto);
    }

    public createDefault(): this {
        return new RemoteDepositBatch(defaultBatchModelDto, new RemoteDepositLocation()) as this;
    }

    public get locationName() {
        return this.location?.name ?? this.dto.locationName ?? '';
    }

    public get batchNumber() {
        return this.dto.batchNumber;
    }

    public get batchReference() {
        return this.dto.batchReference;
    }

    public get events() {
        return this.dto.events;
    }

    public get totalAmount() {
        return this.dto.totalAmount;
    }

    public get status(): string | undefined {
        return this.dto.status;
    }

    public set status(status: string) {
        this.dto.status = status;
    }

    public get statusDescription() {
        return this.dto.statusDescription;
    }

    public get date() {
        const { events } = this.dto;

        if (!events || events.length === 0) {
            return new Date();
        }

        const lastEvent = events[events.length - 1];
        return new Date(lastEvent.date);
    }
}
